import * as PIXI from 'pixi.js'

let _app;
let sceneImg = new PIXI.Graphics();
let selectionBox = new PIXI.Graphics();
let areaStartX = 0;
let areaStartY = 0;
let areaEndX = 0;
let areaEndY = 0;
let isDragging = false;

let _isStaticCanvas = false;
let _imageWidth = 0;
let _imageHeight = 0;

let _onSelectionBoxConfirmed = (e) => { };

class CanvasModel {

    constructor(app, onSelectionBoxConfirmed, isStaticCanvas = false) {
        _app = app;

        _onSelectionBoxConfirmed = onSelectionBoxConfirmed;

        _isStaticCanvas = isStaticCanvas;
    }

    clearAllChildren() {
        while(_app.stage.children.length != 0) {
            for (var i = 0; i < _app.stage.children.length; i++) {
                _app.stage.removeChild(_app.stage.children[i]);
            }
        }
    }

    setupSceneImage(imageSource, imageWidth, imageHeight) {
        _imageWidth = imageWidth;
        _imageHeight = imageHeight;

        sceneImg = PIXI.Sprite.from(imageSource);
        sceneImg.anchor.set(0);
        sceneImg.x = 0;
        sceneImg.y = 0;
        sceneImg.scale.x *= 700 / _imageWidth;
        sceneImg.scale.y *= 500 / _imageHeight;        
        sceneImg.interactive = true;
    
        _app.stage.addChild(sceneImg);

        if (_isStaticCanvas) {
            return;
        }

        sceneImg.on('mousedown', function (e) {
            areaStartX = e.data.global.x;
            areaStartY = e.data.global.y;
    
            isDragging = true;

            _app.stage.removeChild(selectionBox);
            _app.stage.addChild(selectionBox);
        });
    
        sceneImg.on('mousemove', function (e) {
            if (isDragging) {
                areaEndX = e.data.global.x;
                areaEndY = e.data.global.y;

                selectionBox.clear();
                selectionBox.lineStyle(2, 0xFEEB77, 1);
                selectionBox.drawRect(areaStartX, areaStartY, areaEndX - areaStartX, areaEndY - areaStartY);
            }
        });
    
        sceneImg.on('mouseup', function (e) {
            areaEndX = e.data.global.x;
            areaEndY = e.data.global.y;
    
            if (isDragging) {
                isDragging = false;

                _onSelectionBoxConfirmed();
            }
        });
    }

    drawGrid() {
        for (var hli = 0; hli < _app.screen.height; hli += 20) {
            let hl = new PIXI.Graphics();
            hl.lineStyle(1, 0xD9D8D0, 0.45)
                .moveTo(0, hli)
                .lineTo(_app.screen.width, hli);
    
            _app.stage.addChild(hl);
        }

        for (var vli = 0; vli < _app.screen.width; vli += 20) {
            let vl = new PIXI.Graphics();
            vl.lineStyle(1, 0xD9D8D0, 0.45)
                .moveTo(vli, 0)
                .lineTo(vli, _app.screen.height);
    
            _app.stage.addChild(vl);
        }

        _app.renderer.render(_app.stage);
    }

    getSceneImage() {
        return sceneImg;
    }

    getSelectionBox() {
        return selectionBox;
    }

    getAreaCoordinates() {
        return {
            startX: areaStartX,
            startY: areaStartY,
            endX: areaEndX,
            endY: areaEndY
        };
    }

    getImageWidth() {
        return _imageWidth;
    }

    getImageHeight() {
        return _imageHeight;
    }

    isDragging() {
        return isDragging;
    }

    resetSelectionBox() {
        areaStartX = 0;
        areaStartY = 0;
        areaEndX = 0;
        areaEndY = 0;
        selectionBox.clear();
    }

    confirmSelectionBox(tagName) {
        if (areaStartX > areaEndX) { 
            var tempX = areaStartX;
            areaStartX = areaEndX; 
            areaEndX = tempX;
        }

        if (areaStartY > areaEndY) { 
            var tempY = areaStartY;
            areaStartY = areaEndY; 
            areaEndY = tempY;
        }
        
        let graphics = new PIXI.Graphics();
        graphics.lineStyle(2, 0x4287F5, 1);
        graphics.drawRect(areaStartX, areaStartY, areaEndX - areaStartX, areaEndY - areaStartY);

        _app.stage.addChild(graphics);

        let textBackground = new PIXI.Graphics();
        textBackground.beginFill(0x4287F5);
        textBackground.lineStyle(2, 0x4287F5, 1);
        textBackground.drawRect(areaStartX + 4, areaStartY + 4, tagName.length * 8, 14);

        _app.stage.addChild(textBackground);

        var basicTextStyle = {
            fontSize : 10,
            fill : '#FFFFFF',
            strokeThickness : 0
        };

        let basicText = new PIXI.Text(tagName, basicTextStyle);
        basicText.x = areaStartX + 6;
        basicText.y = areaStartY + 4;
        basicText.interactive = true;
        _app.stage.addChild(basicText);

        _app.renderer.render(_app.stage);

        return {
            selectionBox: graphics,
            text: basicText,
            textBackground: textBackground,
            width: (areaEndX - areaStartX) / 700, 
            height: (areaEndY - areaStartY) / 500, 
            left: areaStartX / 700, 
            top: areaStartY / 500,
        };
    }

    unconfirmSelectionBox(target) {
        target.selectionBox.clear();
        _app.stage.removeChild(target.selectionBox);

        target.textBackground.clear();
        _app.stage.removeChild(target.textBackground);

        _app.stage.removeChild(target.text);
        _app.renderer.render(_app.stage);
    }

    renderSelectionBoxForExistingTag(currentTag) {
        let x = currentTag.left * 700;
        let y = currentTag.top * 500;
        let w = currentTag.width * 700;
        let h = currentTag.height * 500;

        let graphics = new PIXI.Graphics();
        graphics.lineStyle(2, 0x4287F5, 1);
        graphics.drawRect(x, y, w, h);

        _app.stage.addChild(graphics);

        let textBackground = new PIXI.Graphics();
        textBackground.beginFill(0x4287F5);
        textBackground.lineStyle(2, 0x4287F5, 1);
        if (currentTag.tagName != null)
        {
            textBackground.drawRect(x + 4, y + 4, currentTag.tagName.length * 8, 14);
        }

        _app.stage.addChild(textBackground);

        var basicTextStyle = {
            fontSize : 10,
            fill : '#FFFFFF',
            strokeThickness : 0
        };

        let basicText = new PIXI.Text(currentTag.tagName, basicTextStyle);
        basicText.x = x + 6;
        basicText.y = y + 4;
        basicText.interactive = true;
        _app.stage.addChild(basicText);

        _app.renderer.render(_app.stage);

        return {
            selectionBox: graphics,
            text: basicText,
            textBackground: textBackground,
        };
    }
}




export default CanvasModel